import { createAPI } from '@common'
export default {
  // 读一个租户的行政区划管理
  getRrTenant: config => createAPI('customEncryptApiName-1/0w20ss0ufobou', 'GET', config),
  // 修改一个租户的行政区划管理
  postRrTenantsCity: config => createAPI('customEncryptApiName-1/0w20ss0ufobou', 'POST', config),
  // 读行政地区
  getRrDistricts: config => createAPI('customEncryptApiName-1/0w20ss0ejtusjdut', 'GET', config),
  // 刷新缓存接口
  postRrTenantsCitiesCache: config => createAPI('customEncryptApiName-1/0w20ss0ufobout0djujft0dbdif', 'POST', config)
}
